<template>
    <div style="color: #e9e9e9;">
        <div style="text-align: center;font-size: 20px;margin-bottom: 8px;">
            <strong>表情包meta.yml生成工具</strong>
        </div>
        <input v-on:change="onSelect" type="file" webkitdirectory>
        <div>点击选择文件夹（仅Webkit），或者空白处关闭</div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { exportFile } from "../utils/Utils";
import yaml from 'js-yaml'

export default defineComponent({
    name: 'smilieset-generate',
    data: () => ({
        onFinish: null as null | (() =>void)
    }),
    methods: {
        onSelect(e: Event) {
            let files: Array<string> = []
            for (const file of (e.target as any)?.files ?? [])
                files.push(file.name)
            
            if(files.length == 0)
            {
                alert('没有选择任何文件')
                this.finish()
                return
            }

            // 获取文件夹名字
            let rpath = (e.target as any)?.files[0].webkitRelativePath as string ?? ''
            let dirname = rpath.substring(0, rpath.indexOf('/'))
            
            let meta = yaml.dump({
                name: dirname,
                cover: files[0],
                smilies: files
            })

            console.log(meta);

            exportFile(meta, 'meta.yml-'+dirname+'.txt')
            this.finish()
        },
        finish() {
            this.$nextTick(() => {
                this.onFinish && this.onFinish();
            })
        }
    }
})

</script>

<style lang="stylus">
    
</style>